import React, { useEffect, useState } from "react";
import serviceManpower from "../assests/revamp/service-manpower.png";
import servicePeo from "../assests/revamp/service-peo.png";
import serviceHrOutsourcing from "../assests/revamp/service-hr-outsourcing.png";
import serviceRecruitment from "../assests/revamp/service-recruitment.png";
import serviceItStaffing from "../assests/revamp/service-it-staffing.png";
import servicePayroll from "../assests/revamp/service-payroll.png";
import { useLanguage } from "../i18n/LanguageContext";

/**
 * Six services, order 1 → 4 → 3 → 6 → 2 → 5.
 * Tap expands over the neighbor in the same row (last column expands left).
 */
const SERVICES = [
  { id: "manpower", img: serviceManpower },
  { id: "recruitment", img: serviceRecruitment },
  { id: "hr", img: serviceHrOutsourcing },
  { id: "payroll", img: servicePayroll },
  { id: "pro", img: servicePeo },
  { id: "it", img: serviceItStaffing },
];

export default function ServicesUpdate() {
  const { t, copy } = useLanguage();
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [columns, setColumns] = useState(3);

  const handleTalkAboutService = (event, title) => {
    event.stopPropagation();
    const getInTouchSection = document.getElementById("contact_us");
    if (getInTouchSection) {
      const topOffset = getInTouchSection.offsetTop - 90;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
    window.sessionStorage.setItem("amgEnquiryService", title);
  };

  useEffect(() => {
    const updateCols = () => {
      if (window.matchMedia("(max-width: 600px)").matches) setColumns(1);
      else if (window.matchMedia("(max-width: 992px)").matches) setColumns(2);
      else setColumns(3);
    };
    updateCols();
    window.addEventListener("resize", updateCols);
    return () => window.removeEventListener("resize", updateCols);
  }, []);

  useEffect(() => {
    if (expandedIndex == null) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setExpandedIndex(null);
    };
    const onPointer = (e) => {
      if (!(e.target instanceof Element)) return;
      if (!e.target.closest(".amgServiceCard")) setExpandedIndex(null);
    };
    window.addEventListener("keydown", onKey);
    document.addEventListener("pointerdown", onPointer);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.removeEventListener("pointerdown", onPointer);
    };
  }, [expandedIndex]);

  const toggleCard = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  const openCol = expandedIndex == null ? -1 : expandedIndex % columns;
  const expandLeft = columns > 1 && openCol === columns - 1;
  const coveredIndex =
    expandedIndex == null || columns === 1
      ? -1
      : expandLeft
        ? expandedIndex - 1
        : expandedIndex + 1;

  return (
    <div className="servicesMain" id="our__services">
      <div className="servicesHeadContainer">
        <div className="servicesHeadings">
          <h2 className="servicesHeadingText">{t("services.heading")}</h2>
          <p className="servicesParaText">{t("services.lead")}</p>
        </div>
      </div>

      <div
        className={`amgServiceGrid${expandedIndex != null ? " amgServiceGrid--hasOpen" : ""}`}
      >
        {SERVICES.map((service, index) => {
          const copyItem = copy.services.items[service.id];
          const isOpen = expandedIndex === index;
          const isCovered = coveredIndex === index;
          const isDimmed =
            expandedIndex != null && !isOpen && !isCovered;
          const col = index % columns;
          const isExpandLeft = columns > 1 && col === columns - 1;

          return (
            <div
              key={service.id}
              className={[
                "amgServiceSlot",
                isOpen ? "amgServiceSlot--open" : "",
                isCovered ? "amgServiceSlot--covered" : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              <article
                className={[
                  "amgServiceCard",
                  isOpen ? "amgServiceCard--open" : "",
                  isCovered ? "amgServiceCard--covered" : "",
                  isDimmed ? "amgServiceCard--dimmed" : "",
                  isExpandLeft
                    ? "amgServiceCard--expandLeft"
                    : "amgServiceCard--expandRight",
                ]
                  .filter(Boolean)
                  .join(" ")}
                role="button"
                tabIndex={isCovered ? -1 : 0}
                aria-expanded={isOpen}
                aria-hidden={isCovered || undefined}
                onClick={(event) => {
                  event.stopPropagation();
                  if (isCovered) return;
                  toggleCard(index);
                }}
                onKeyDown={(event) => {
                  if (isCovered) return;
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    toggleCard(index);
                  }
                }}
              >
                <div className="amgServiceCardMedia">
                  <img src={service.img} alt="" loading="lazy" />
                </div>
                <div className="amgServiceCardBody">
                  <h3 className="amgServiceCardTitle">{copyItem.title}</h3>
                  <div
                    className={
                      isOpen
                        ? "amgServiceCardCopy amgServiceCardCopy--open"
                        : "amgServiceCardCopy"
                    }
                  >
                    <p className="amgServiceCardPara">{copyItem.para}</p>
                    <p className="amgServiceCardDetail">{copyItem.detail}</p>
                    {isOpen ? (
                      <button
                        type="button"
                        className="amgServiceCardCta"
                        onClick={(event) =>
                          handleTalkAboutService(event, copyItem.title)
                        }
                      >
                        {t("services.enquire")}
                      </button>
                    ) : null}
                  </div>
                  <span className="amgServiceCardMore" aria-hidden="true">
                    {isOpen ? t("services.less") : t("services.more")}
                  </span>
                </div>
              </article>
            </div>
          );
        })}
      </div>
    </div>
  );
}
